// extracted by mini-css-extract-plugin
module.exports = {"ResetPassword":"ResetPassword_ResetPassword__3mW9c","help-block":"ResetPassword_help-block__3_KBS"};